import styled from 'styled-components';

export const ImgWrapper = styled.div`
  margin-top: 1.042vw;
  max-height: 75%;
  align-self: center;
`;

export const ImgContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
`;
